import { Link } from "react-router-dom";
import type { Work } from "@/types/content";

interface WorkCardProps {
  work: Work;
  rank?: number;
}

export default function WorkCard({ work, rank }: WorkCardProps) {
  return (
    <Link
      to={`/detail/${work.id}`}
      className="group block rounded-lg overflow-hidden border border-background-200 bg-background-50 hover:border-primary-300 transition-colors"
    >
      <div className="relative w-full aspect-[3/4] overflow-hidden bg-background-200">
        <img
          src={work.cover}
          alt={work.title}
          title={`${work.title} 影视作品海报`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-2 left-2 flex items-center gap-1 bg-accent-500 text-background-50 px-2 py-0.5 rounded-md text-xs font-label font-semibold">
          <i className="ri-star-fill" />
          {work.rating.toFixed(1)}
        </div>
        {rank !== undefined && (
          <div className="absolute bottom-0 left-0 w-9 h-9 flex items-center justify-center bg-primary-500 text-background-50 font-label text-lg font-bold rounded-tr-lg">
            {rank}
          </div>
        )}
        <div className="absolute top-2 right-2 bg-foreground-950/60 text-background-50 px-2 py-0.5 rounded-md text-[11px]">
          {work.type}
        </div>
      </div>
      <div className="p-3">
        <h3 className="font-heading font-bold text-sm text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
          {work.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1.5 truncate">
          导演 {work.director}
        </p>
        <div className="flex items-center gap-1.5 mt-2 text-xs text-foreground-600 flex-wrap">
          <span className="text-foreground-800">{work.year}</span>
          <span className="text-background-400">·</span>
          <span className="truncate">{work.genre.join(" / ")}</span>
        </div>
      </div>
    </Link>
  );
}